import { HeaderBoxAutoSafe, HeaderLogo } from "./layout";

export default function LogoHeader() {
  return (
    <HeaderBoxAutoSafe>
      <HeaderLogo />
    </HeaderBoxAutoSafe>
  );
}
